import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import {Publication, PublicationService} from "../../../services/publication.service";

@Component({
    selector: 'app-blog-details',
    templateUrl: './blog-details.component.html',
    styleUrls: ['./blog-details.component.scss']
})
export class BlogDetailsComponent implements OnInit, OnDestroy {
    id!: number;
    type!: 'BLOG' | 'PROJECT';
    enterprise: string = 'ASESA';

    loading = false;
    publication?: Publication;

    // images pour le carrousel (URLs directes)
    images: string[] = [];
    // fallback blob URL si besoin
    mainBlobUrl?: string;

    private subs: Subscription[] = [];

    constructor(
        private route: ActivatedRoute,
        private publicationService: PublicationService
    ) {}

    ngOnInit(): void {
        this.id = Number(this.route.snapshot.paramMap.get('id')!);
        this.type = (this.route.snapshot.paramMap.get('type') || 'BLOG') as 'BLOG' | 'PROJECT';

        this.loadPublication();
    }

    private loadPublication(): void {
        this.loading = true;

        // 1) Publication
        const s1 = this.publicationService.getById(this.id, this.enterprise).subscribe({
            next: (pub) => {
                this.publication = pub;

                // 2) Images: on tente la liste des fichiers → URLs directes
                const s2 = this.publicationService
                    .listImages(pub.enterprise, pub.type, pub.id)
                    .subscribe({
                        next: (files) => {
                            if (files?.length) {
                                this.images = files.map((f) =>
                                    this.publicationService.buildImageUrlForFilename(pub.enterprise, pub.type, pub.id, f)
                                );
                            } else {
                                // 3) Fallback : on essaye au moins la première image (blob)
                                const s3 = this.publicationService
                                    .getFirstImage(pub.enterprise, pub.type, pub.id)
                                    .subscribe({
                                        next: (blob) => (this.mainBlobUrl = URL.createObjectURL(blob)),
                                        error: () => (this.images = []) // aucun média
                                    });
                                this.subs.push(s3);
                            }
                        },
                        error: () => {
                            this.images = [];
                        },
                        complete: () => (this.loading = false)
                    });

                this.subs.push(s2);
            },
            error: () => (this.loading = false)
        });

        this.subs.push(s1);
    }

    ngOnDestroy(): void {
        if (this.mainBlobUrl?.startsWith('blob:')) {
            URL.revokeObjectURL(this.mainBlobUrl);
        }
        this.subs.forEach((s) => s.unsubscribe());
    }
}
